import React from 'react'
import { NonaGrayImg } from '../../assets/images/images'
import './stripe.css'

/* Fallback page for Stripe Identity: shown only if the return URL opens outside the app. */
export default function IdentityReturnUrl() {
    return (
        <div className="stripe">
            <div className="container">
                <section className='logo'>
                    <img src={NonaGrayImg} alt="" />
                </section>
                <section>
                    <h3 className="success-text">Your ID verification has been submitted. You can now return to the Nona app.</h3>
                </section>
            </div>
        </div>
    )
}
